import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatisticComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ICampaignRunEstimates } from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-campaign-run-estimates',
  templateUrl: './campaign-run-estimates.component.html',
  styleUrl: './campaign-run-estimates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-4' },
  imports: [NgCommonModule, StatisticComponent],
})
export class CampaignRunEstimatesComponent {
  estimates = input.required<ICampaignRunEstimates>();
}
